import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  featureWrapper: FelaCSS;
  title: FelaCSS;
  subTitle: FelaCSS;
  featureIcon: (color: string) => FelaCSS;
}

const styles = (): IStyles => ({
  featureWrapper: {
    flexDirection: 'row',
    marginVertical: 2,
    alignItems: 'center',
    paddingVertical: 6,
    borderBottom: `1px solid ${colors.space08}`,
    cursor: 'pointer',
  },
  title: {
    color: colors.space,
    fontDefaultSemiBold: 14,
  },
  subTitle: {
    color: colors.space75,
    fontDefault: 12,
    maxWidth: '70%',
  },
  featureIcon: (color) => ({
    backgroundColor: color,
    width: '25%',
    paddingHorizontal: 6,
    paddingVertical: 6,
    borderRadius: '8px',
    justifyContent: 'center',
    alignItems: 'center',
  }),
});

export default styles;
